import { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCircle2, Clock, Users } from 'lucide-react';

const Liste = ({ titre, items, testId }) => (
  <div data-testid={testId}>
    <p className="mt-3 flex items-center text-sm font-semibold text-slate-600">
      {titre}
      <span className="ml-2 text-xs font-medium text-slate-400" data-testid={`${testId}-compteur`}>{items.filter((s) => s.engage_le).length}/{items.length}</span>
    </p>
    {items.length === 0 && <p className="py-2 text-sm text-slate-400">Aucun</p>}
    <ul className="grid gap-x-6 sm:grid-cols-2">
      {items.map((s) => (
        <li key={s.user_id} className="flex items-center justify-between border-b border-slate-100 py-2 text-sm" data-testid={`livret-base-eng-${s.user_id}`}>
          <span className="capitalize">{s.prenom} {s.nom}</span>
          {s.engage_le
            ? <span className="inline-flex items-center gap-1 text-emerald-700"><CheckCircle2 className="h-4 w-4" /> {new Date(s.engage_le).toLocaleDateString('fr-FR')}</span>
            : <span className="inline-flex items-center gap-1 text-slate-400"><Clock className="h-4 w-4" /> En attente</span>}
        </li>
      ))}
    </ul>
  </div>
);

export const EngagementsLivretBase = () => {
  const [liste, setListe] = useState(null);
  useEffect(() => { axios.get('/livret-base/engagements').then(({ data }) => setListe(data)).catch(() => setListe([])); }, []);
  if (!liste) return null;
  const faits = liste.filter((s) => s.engage_le).length;
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="livret-base-engagements">
      <h2 className="flex items-center gap-2 text-base md:text-lg font-semibold text-[#0F172A]">
        <Users className="h-5 w-5 text-[#8DC63F]" /> Engagements
        <span className="ml-auto text-sm font-medium text-slate-500" data-testid="livret-base-engagements-compteur">{faits}/{liste.length}</span>
      </h2>
      <Liste titre="Stagiaires" items={liste.filter((s) => s.type !== 'tuteur')} testId="livret-base-eng-stagiaires" />
      <Liste titre="Tuteurs" items={liste.filter((s) => s.type === 'tuteur')} testId="livret-base-eng-tuteurs" />
    </section>
  );
};
